import * as Styled from './OxTextHeading.styled';

import React, { PropsWithChildren } from 'react';

type TProps = PropsWithChildren<unknown>;

export const OxTextHeading = ({ children }: TProps): JSX.Element => {
    return <Styled.Heading>{children}</Styled.Heading>;
};
